
export function descriptionScheme(Scheme) {
  try {
    return !Scheme ? '' : `${Scheme.Name}, ${Scheme.LocalityType}. ${
      Scheme.Participants.Minimum && Scheme.Participants.Maximum
        && Scheme.Participants.Minimum === Scheme.Participants.Maximum
        ? `Participants: ${Scheme.Participants.Minimum}` : ''
    }${Scheme.Participants.Minimum && Scheme.Participants.Maximum
        && Scheme.Participants.Minimum !== Scheme.Participants.Maximum
      ? `Participants: ${Scheme.Participants.Minimum} - ${Scheme.Participants.Maximum}` : ''
    }${Scheme.Participants.Minimum && !Scheme.Participants.Maximum
      ? `Participants: from ${Scheme.Participants.Minimum}` : ''
    }${!Scheme.Participants.Minimum && Scheme.Participants.Maximum
      ? `Participants: up to ${Scheme.Participants.Maximum}` : ''
    }${Scheme.Participants.Default ? `. Default: ${Scheme.Participants.Default}` : ''}`;
  }
  catch (e) {
    console.error('unable to compute scheme name');
    return '';
  }
}

function initializeProductFormData(productData) {
  const {
    Id = 0,
    Name = '',
    FacilityId = '',
    FacilityName = '',
    ProviderId = '',
    Type = '',
    Category = '',
    SubType = {},
    Summary = '',
    Description = '',
    PurchaseText = '',
    IsVisible = true,
    IsExclusive = false,
    CreatedAt = '',
    SchemeName = '',
    Photos = {
      SquareUrl: '',
      BannerUrl: '',
      HugeUrl: ''
    },
    Scheme = null,
    GroupId = '',
    Group = {
      Name: ''
    },
    Price = {},
    ExternalLink = '',
    TermsOfServiceLink = ''
  } = productData || {};
  const {Id: SubTypeId } = SubType;
  const { SquareUrl, BannerUrl, HugeUrl } = Photos;
  const SchemeDescription = descriptionScheme(Scheme);
  const GroupName = Group.Name;
  const {
    Amount = '',
    TaxAmount = '',
    CurrencyIsoCode = '',
    ServiceFeeAmount = '',
    Level: PriceLevel = '',
    TaxIndex = {
      AsDecimal: 0.0
    }
  } = Price;
  const TaxIndexAsPercentage = TaxIndex.AsDecimal * 100;

  return {
    Name,
    ProviderId: { value: ProviderId, label: ProviderId },
    Facility: { value: FacilityId, label: FacilityName },
    Summary,
    Description,
    PurchaseText,
    Id,
    Type,
    IsVisible,
    IsExclusive,
    CreatedAt,
    Category: Category && Category.split(', ').length > 1 ? Category.split(', ')[0] : Category,
    SubType,
    SubTypeId: SubTypeId || '',
    SchemeName,
    SchemeDescription,
    GroupId,
    GroupName,
    Group: { value: GroupId, label: GroupName },
    SquareUrl,
    HugeUrl,
    BannerUrl,
    Amount,
    CurrencyIsoCode,
    TaxIndexAsPercentage,
    TaxAmount,
    ServiceFeeAmount,
    ExternalLink,
    TermsOfServiceLink,
    PriceLevel
  };
}

export function bookingFormData(bookingData) {
  const productFormData = initializeProductFormData(bookingData);
  const {
    SignUpDeadLine = '',
    SignUpCancellationDeadline = '',
    MaxSignUpInAdvanceInDays = ''
  } = bookingData || {};

  return Object.assign(productFormData, {
    SignUpDeadLine,
    SignUpCancellationDeadline,
    MaxSignUpInAdvanceInDays
  });
}

export function ticketFormData(ticketData) {
  const productFormData = initializeProductFormData(ticketData);
  const {
    SignUpDeadLine = '',
    SignUpCancellationDeadline = '',
    MaxSignUpInAdvanceInDays = ''
  } = ticketData || {};

  return Object.assign(productFormData, {
    SignUpDeadLine,
    SignUpCancellationDeadline,
    MaxSignUpInAdvanceInDays
  });
}

export function classFormData(classData) {
  const productFormData = initializeProductFormData(classData);
  const {
    SignUpDeadLine = '',
    SignUpCancellationDeadline = '',
    MaxSignUpInAdvanceInDays = ''
  } = classData || {};

  return Object.assign(productFormData, {
    SignUpDeadLine,
    SignUpCancellationDeadline,
    MaxSignUpInAdvanceInDays
  });
}

export function membershipFormData(membershipData) {
  const productFormData = initializeProductFormData(membershipData);
  const {
    DefaultPriceCoverage = '',
    MaxDiscountedAmount = '',
    IsAllProductsIncluded = false,
    CategoriesIncluded,
    MaxPurchasesIncluded = '',
    FixedDiscount = '',
    CoveredFacilityId = '',
    DefaultPriceLevelCoverage = '',
    TrackDiscountedAmount = '',
    OneTimeSubscription = '',
    PeriodInMonths = '0',
    DeferredStart = null,
    LogicType = '',
    IsMonthlyBilled = true,
    EmailDomain = null
  } = membershipData || {};

  return Object.assign(productFormData, {
    DefaultPriceCoverage,
    MaxDiscountedAmount,
    IsAllProductsIncluded,
    CategoriesIncluded: CategoriesIncluded ? CategoriesIncluded.split(', ') : [],
    MaxPurchasesIncluded,
    FixedDiscount,
    CoveredFacilityId: CoveredFacilityId ? ({ value: CoveredFacilityId, label: CoveredFacilityId }) : '',
    OneTimeSubscription,
    DefaultPriceLevelCoverage,
    TrackDiscountedAmount,
    DeferredStart,
    LogicType,
    IsMonthlyBilled,
    TerminationPeriodInMonths: PeriodInMonths,
    EmailDomain
  });
}